import React from 'react';

import Icon from '@ant-design/icons';
import { addIcon, minusIcon } from 'components/common';

export const renderExpandIcon = ({ isActive }: any) => {
  return <Icon component={isActive ? minusIcon : addIcon} />;
};
